<div class="send_pricing_requests">
  <form [formGroup]="form">
    <mat-form-field>
      <mat-label>Proveedores</mat-label>
      <mat-select formControlName="provider_ids" multiple>
        <button type="button" mat-button (click)="addProvider()">Agregar Nuevo Proveedor</button>
        <mat-option selectAll [value]="0">Seleccionar Todos</mat-option>
        <mat-option *ngFor="let provider of providers()" [value]="provider.id">{{ provider.name }}</mat-option>
      </mat-select>
    </mat-form-field>
  </form>
  <button type="button" mat-raised-button (click)="send_pricing_requests()" [disabled]="!canSendPricingRequests">Enviar Solicitudes de Cotización</button>
</div>

@if (workInstance.pending_pricings_count) {
  <p>{{ workInstance.pending_pricings_count }} {{ workInstance.pending_pricings_count === 1 ? 'solicitud': 'solicitudes' }} de cotización sin respuesta.</p>
}

@if (workInstance.sent_pricings.length > 0) {
  <div>
    <div class="subtitle">Cotizaciones Recibidas</div>
    <mat-accordion multi>
      @for(product_id of productsIds; track product_id) {
        <mat-expansion-panel class="budget-expansion-panel-works expansion-panel">
          <mat-expansion-panel-header>
              <div class="panel-title">
                {{mapProductPricing[product_id].at(0).name}}
              </div>
          </mat-expansion-panel-header>
          <mat-table [dataSource]="mapProductPricing[product_id]">
            <ng-container matColumnDef="select">
              <mat-header-cell *matHeaderCellDef></mat-header-cell>
              <mat-cell *matCellDef="let product">
                <mat-checkbox (change)="$event.checked ? selectProduct(product): deselectProduct(product)">
                </mat-checkbox>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="provider_name">
              <mat-header-cell *matHeaderCellDef> Proveedor </mat-header-cell>
              <mat-cell *matCellDef="let product"> {{ product.ownerName }} </mat-cell>
            </ng-container>
            <ng-container matColumnDef="amount">
              <mat-header-cell *matHeaderCellDef> Precio Ofrecido </mat-header-cell>
              <mat-cell *matCellDef="let product"> {{ product.amount | money }} </mat-cell>
            </ng-container>
            <ng-container matColumnDef="quantity">
              <mat-header-cell *matHeaderCellDef> Cantidad Ofrecida </mat-header-cell>
              <mat-cell *matCellDef="let product"> {{ product.offered_quantity }} </mat-cell>
            </ng-container>
            <ng-container matColumnDef="total">
              <mat-header-cell *matHeaderCellDef> Total </mat-header-cell>
              <mat-cell *matCellDef="let product"> {{ product.amount * product.quantity | money }} </mat-cell>
            </ng-container>
            <ng-container matColumnDef="estimated_completion_date">
              <mat-header-cell *matHeaderCellDef> Fecha mínima de entrega </mat-header-cell>
              <mat-cell *matCellDef="let product"> {{product.estimated_completion_date | date }} </mat-cell>
            </ng-container>
            <ng-container matColumnDef="expiration_date">
              <mat-header-cell *matHeaderCellDef> Fecha de expiración </mat-header-cell>
              <mat-cell *matCellDef="let product"> {{ product.expiration_date | date }} </mat-cell>
            </ng-container>
            <ng-container matColumnDef="flexible">
              <mat-header-cell *matHeaderCellDef> Flexible <i class="fa fa-question-circle" matTooltip="Está dispuesto a vender menor cantidad al mismo precio"></i> </mat-header-cell>
              <mat-cell *matCellDef="let product"> {{ product.flexible ? 'Si' : 'No' }} </mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="displayedInnerColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedInnerColumns"></mat-row>
          </mat-table>
        </mat-expansion-panel>
      }

    </mat-accordion>
  
    <mat-paginator [pageSizeOptions]="[10, 20, 50, 100]"
      showFirstLastButtons
      aria-label="Select page of periodic elements">
    </mat-paginator>
  </div>

  <div class="summary">
    <div>
      <div class="subtitle">Requerido</div>
        @for(product of workInstance.required_products; track product.id) {
          <p>{{getChosenCount(product.product_id)}}/{{product.quantity}} de {{product.name}}
            @if (getChosenCount(product.product_id) >= product.quantity) {
              <i class="fa fa-check-circle"></i>
            }
          </p>
        }
    </div>
    <div>
      <div class="subtitle">Elegidos</div>
        @for(product of chosenProducts; track product.id) {
          <p><input type="number" class="chosen-quantity-input" (change)="checkQuantity(product)" [(ngModel)]="product.quantity" min="1" [max]="product.offered_quantity" [disabled]="!product.flexible"> {{product.name}} de {{product.ownerName}}</p>
        }
    </div>
    <div>
      <div class="subtitle">Total</div>
        <p>{{ chosenTotal | money }}</p>
    </div>
  </div>
}
